import * as React from "react";
import MobileViewDrawer from "./mobileViewDrawer/mobileViewDrawer";

import NavBar from "./NavBar";

import WebViewDrawer from "./webViewDrawer/webViewDrawer";

export default function MiniDrawer(props) {
  const { open, setOpen, isItBelowTabletView } = props;

  const handleDrawerOpen = () => {
    setOpen(!open);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NavBar open={open} handleDrawerOpen={handleDrawerOpen} />
      {isItBelowTabletView ? (
        <MobileViewDrawer setOpen={setOpen} open={open} handleDrawerClose={handleDrawerClose} />
      ) : (
        <WebViewDrawer open={open} handleDrawerClose={handleDrawerClose} />
      )}
    </>
  );
}
